import { useBusinessInfo } from '../../lib/Queries';
import { useEffect, useState } from 'react';
import TimezoneSelect from '../TimezoneSelect.jsx';

const OptionalTimeZoneSelect = ({
    value,
    onChange,
    noLink,
    defaultLabel,
    inputLabel,
    btnClassName,
    className,
    selectClassName,
}) => {
    const [showOption, setShowOption] = useState(!!value);
    const { data, isLoading } = useBusinessInfo();
    const businessTimezone = data?.business?.timezone;

    useEffect(() => {
        if (
            !showOption &&
            !!value &&
            !!businessTimezone &&
            businessTimezone !== value
        ) {
            setShowOption(true);
        }
    }, [value, businessTimezone]);

    return (
        <div className={`${className}`}>
            {!showOption && (
                <button
                    className={`${noLink ? '' : 'link'} ${btnClassName}`}
                    onClick={() => setShowOption(true)}
                >
                    {defaultLabel ||
                        'This has a time zone different than the business'}
                </button>
            )}
            {showOption && (
                <div>
                    <TimezoneSelect
                        value={value || businessTimezone}
                        onChange={onChange}
                        label={inputLabel || 'Time Zone'}
                        inputClassName="w-full"
                        className={selectClassName}
                    />
                    <div className="text-sm text-gray-500 ml-4">
                        This business is set to {businessTimezone}
                    </div>
                </div>
            )}
        </div>
    );
};

export default OptionalTimeZoneSelect;
